import { Methods } from "@newview/infrastructure";
import { basicBaseApi } from "./basicBaseApi";
/**
* Api描述：单位工程模板
* 创 建人msh
* 日   期：2022/09/05 13:50:04
*/
export class StructureInstancetemplateApi extends basicBaseApi {
  public get ControllerName(): any {
    return 'structureinstancetemplate'
  }
  /**
  * 函数描述：保存划分数据
  * @param list 划分行数据
  */
  public insertOrUpdateList(list: any) {
    return this.send(list, "insertOrUpdateList", Methods.POST);
    //return this.send({Id:ZZZZZ},"接口方法名称",Methods.GET);
  }
  /**
  * 函数描述：获取划分模板数据
  */
  public getTemplateList() {
    return this.send({}, "getTemplateList", Methods.GET);
  } 
  /**
   * 获取单位工程下的三层以上的节点（同步节点）
   * @param RootId 
   * @returns 
   */
  public getStructeInstanceData(RootId:number,isAll:number=0){
    return this.send({RootId,isAll}, "getStructeInstanceData", Methods.GET);
  }
  /**
   * 获取单位工程三层以下的节点(异步节点)
   * @param rootId 
   * @param PId 
   * @returns 
   */
  public getListByRootIdAndPId(rootId:number,PId:number){
    return this.send({rootId,PId}, "getListByRootIdAndPId", Methods.GET);
  }
  
  /**
   * 更新构件类别
   * @param list 
   * @returns 
   */
  public updateStructType(list:any){
    return this.send(list, "updateStructType", Methods.POST);
  }
  /**
   * 删除单位工程数据
   * @param id 
   * @returns 
   */
  public RemoveAllofProject(RootId:number) {
    return this.send({ RootId}, 'RemoveAllofUProject', Methods.GET)
  }
  public delete(ids:string){
    return this.send({ ids}, 'delete', Methods.GET)
  }
}

